var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0_913_318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_913_318",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_913_318",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_913_318",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEPUlEQVR4nO3dSYgcVRgH8BYXXECJK26I+0E8iAEVBA+KpwTUiyIuJyM6BEGMBxFyETKCGygGVBRFzEmjMq4BlYi4oYKgDAqixokYUMw4iiYmPymmAmFwZrqqvte1dP2ODV39/76prnn16lX1YJAADsH92I4ZTGavldzWubgHW/Jt/Y05TOMNTOCUunPWIg+80GTBbZyFzdhref/iSZw06py1yveOhWYKvP8W/KW4WaweVc7aVSkA61WzB2tT52yERb6SG4Z435qKTd6/2atT5WyM/J/MZL7HzAzzTwbnlDxcLGbncsfsMjlbDy+L90TddTWK+SHcMKOLonaXHfp1Eu6VzsSg7aIG/Hg7YaNfq6uuMFEDfv8/zIoyXVddYfK/+EI/l9jOPwkb/UdddYWJGvBjV8JGz9ZVV5ioAb92HDrqO5GJGvCbn4VLZaquuhoHdyds9G1119cYODWf6oy2q+jUaefh2QSNfnTQZWUG/DgZvwU2+VecEJ2zUcoO+HFVPsUZMcdxRaqcXZn4XxfQ6HWpc3ah0QfgzQpNfivbRuqcjVB1wI8LKjT6wlHlrF3EgB/vlWjy1lHn7PV6vXFl/kr2sLbXnbe18GGBRr9Sd97WMr+AcVjX1J23tXAwvhiiyVuGPUnpLQIn4vMlmvwBViz2/l7xE4uJ/Jg9l8/yfYTbs71+MK6yPQzX4XF8ih/xZ3ZFGp/gThw6rnkqwxl5Mdlet5zvcck45QmBW4csaH/Z6tEbcV70IaBpeSrLpzWfUt0vuK/qV7hpecLgQbG+xHFdyRMCV0rjYxzU9jwhsg/GV9K5o815wmCVtH7CgW3NEya/ry+1y9uaJ0w+6E9tfVvzhMiPhymWcC30UhvzhMnWsxmN99uYJwzOHlFhn7UxT/QkzShMtTFPKHw3gsIeaWueMHhgBIWtamueMDg/aOXnYn7H4W3NEwrPJSzsobbnCYPnExa2qe15QuDIRDfK75Nt+6i25gmD06V3WlvzhMERiU9754osoW1anlB4N2Fhj7U9TxhcFPx4nn1+wLFtzxMKK/PHoEWZzeYuupInVP4gwCgvdi1PGFwcdFa2J/v6dy1PKGwMKGxjV/OEyYdX2RqIsr7OTjq6micUzsSOEkXtyN7b9TyhshsqSxS2clzyhCpa1WDM8nS2MA3L09nCNCxP5LrkotYkzHNzk/KEwE35Q0mK2o0bEuS5vuTDC5PkqQzH4xnVPR2xFjnbBl5oSp7KsouV+S9KFLmVeDk7820WvhCKw3BX/jyl2vOEyO9y2iadbbi2QJ6rEy90LJSnMhyD143OFI5eJtOmJuWJaHK2xu1bo/dN9rssS+Ta0KQ8VZu8Iv+AukwvdhU6ez14sr9SnqqNflX9Ni+R7+Em5Snb5Es1x2VL/LzI3qbkKdvolFeXi3pniZxbNShPr9fr9Xq9Xq/X6/V6vd6go/4DXfYYZ4pIEEEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.7cb1f81d2cae4960a4f07c6ad3311e77.svg";
export { ForwardRef as ReactComponent };